var map = {
	"./facts-all_1924.png": "65b2",
	"./facts-all_1929.png": "ba2f",
	"./facts-all_1935.png": "fb7e",
	"./facts-all_1941.png": "732b",
	"./facts-all_1950.png": "122d",
	"./facts-all_1958.png": "b376",
	"./facts-all_1961.png": "0791",
	"./facts-all_1975.png": "8a8f",
	"./facts-all_1984.png": "ef26",
	"./facts-all_1994.png": "1162",
	"./facts-all_2013.png": "9848",
	"./facts-all_2019.png": "fd20"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6b74";